import React from "react";

const FaqQuestions = ({ category, onClick, isActive }) => {
  return (
    <div
      className={`category ${isActive ? "active" : ""}`}
      onClick={() => onClick(category)}
    >
      <span translate="no">{category}</span>
    </div>
  );
};

export default FaqQuestions;
